// extracted by mini-css-extract-plugin
module.exports = {"dataLabelling":"data-labelling_dataLabelling__3gQ9-","header":"data-labelling_header__2oIdd","desc":"data-labelling_desc__13B_J","main":"data-labelling_main__1t2cj"};